import { DEFAULT_ICON_PROPS, ICONS_GAP } from '../constants';

export const getIconOffset = (index: number) =>
    `${
        // Сумма всех предыдущих иконок
        index * DEFAULT_ICON_PROPS.size +
        // Отступы между иконками
        ICONS_GAP * (index + 1) +
        // Общий отступ справа
        ICONS_GAP
    }px`;
